import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="diferenciais"]');

class Diferenciais {
    constructor() {
        this.components = MODULE;
        this.breakpoint = window.matchMedia('(min-width: 1024px)');
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const swiperEl = component.querySelector('.swiper');
            if (!swiperEl) return;

            const state = { swiper: null };
            const handle = () => this.handle(swiperEl, state);

            this.breakpoint.addEventListener('change', handle);
            handle();
        });
    }

    handle(swiperEl, state) {
        if (!this.breakpoint.matches) {
            if (!state.swiper) {
                state.swiper = new Swiper(swiperEl, {
                    modules: [FreeMode],
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    freeMode: true,
                });
            }
        } else if (state.swiper) {
            state.swiper.destroy(true, true);
            state.swiper = null;
        }
    }
}

(() => {
    if (MODULE.length) {
        new Diferenciais();
    }
})();

export default Diferenciais;
